module.exports = __webpack_public_path__ + "static/media/14UNEP2.8285ce36.jpg";